import { useI18n } from './use-i18n';

/**
 * Hook per generare URL localizzate con il prefisso lingua corrente
 * 
 * @example
 * const getLocalizedUrl = useLocalizedUrl();
 * getLocalizedUrl('/scheda/piazza-unita') // '/it/scheda/piazza-unita' se lingua corrente è 'it'
 */
export function useLocalizedUrl() {
  const { language } = useI18n();
  
  return (path: string): string => {
    // Se il path è già localizzato, restituiscilo così com'è
    if (path.match(/^\/(it|en|de|sl)\//)) {
      return path;
    }
    
    // Le route admin non devono essere localizzate
    if (path.startsWith('/admin')) {
      return path;
    }
    
    // Rimuovi eventuali prefissi lingua esistenti (safety)
    // Must match /it, /en, /de, /sl followed by / or end-of-string to avoid
    // stripping lang codes from real path segments (e.g. /itinerari → /inerari)
    const cleanPath = path.replace(/^\/(it|en|de|sl)(\/|$)/, '/');

    // Assicurati che il path inizi con /
    const normalizedPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;

    // Aggiungi il prefisso lingua corrente
    return `/${language}${normalizedPath}`;
  };
}

/**
 * Helper function per aggiungere prefisso lingua a un path
 * (versione non-hook per uso in contesti non-React)
 *
 * @param path - Path senza prefisso lingua
 * @param language - Lingua da usare ('it', 'en', 'de')
 * @returns Path con prefisso lingua
 */
export function addLanguagePrefix(path: string, language: 'it' | 'en' | 'de' | 'sl'): string {
  // Se il path è già localizzato, restituiscilo così com'è
  if (path.match(/^\/(it|en|de|sl)\//)) {
    return path;
  }

  // Le route admin non devono essere localizzate
  if (path.startsWith('/admin')) {
    return path;
  }

  // Rimuovi eventuali prefissi lingua esistenti (safety)
  const cleanPath = path.replace(/^\/(it|en|de|sl)(\/|$)/, '/');
  
  // Assicurati che il path inizi con /
  const normalizedPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
  
  // Aggiungi il prefisso lingua
  return `/${language}${normalizedPath}`;
}


